// A Look is data (W4): its picture is a 3D snapshot on this device, drawn once near view.
import { useRef } from 'react';
import { useNearView } from '../pet3d/useNearView';
import { usePetImage } from '../pet3d/usePetImage';
import type { Outfit } from '../pet3d/types';

const NO_STAINS: never[] = [];   // D11: a Look picture never carries stains

export function LookPicture({ species, stage, worn, alt, className, width, height }: {
  species: string; stage: string; worn: Outfit; alt: string; className?: string; width?: number; height?: number;
}) {
  const ref = useRef<HTMLImageElement>(null);
  const near = useNearView(ref);
  const src = usePetImage(species, stage, 'base', NO_STAINS, worn, near);
  // The span is the thumb's box and crops the 1024 lock frame to the pet (base.css `.look-crop`).
  return (
    <span className={`look-crop ${className ?? ''}`} data-stage={stage}>
      <img ref={ref} src={src} alt={alt} width={width} height={height} />
    </span>
  );
}
